import React from 'react';
import { I18n } from 'aws-amplify';
import { Dropdown } from 'primereact/dropdown';

export const TeamMemberHelp = () => {
    return (<>
        <h3>{I18n.get("Gestion des membres")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <span className='pi pi-video mr-2' style={{ fontWeight: "bold" }}></span><a style={{ color: '#000000' }} href={I18n.get("https://www.cdm.lu/mediatheque/media/comment-ajouter-un-tuteur-a-mon-equipe")} rel="noopener noreferrer" target="_blank">{I18n.get("Vidéo explicative")}</a>
        <div>
            <div className="grid">
                <div className="col"><b></b></div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col">{I18n.get("Cet écran vous permet d'ajouter ou de modifier des utilisateurs au sein de votre équipe et de leur accorder certaines permissions:")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col"><i className='fas fa-key' /> <b>{I18n.get("superviseurs_apprentissage")}</b></div>
            </div>
            <div className="grid">
                <div className="col">{I18n.get("Permet d'accèder à la partie apprentissage, évaluation des apprentis.")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col">{I18n.get("Si vous êtes gérants de plusieurs entreprises, il vous est possible de réutiliser un compte utilisateur de celles-ci.")}</div>
            </div>

            <div className="grid">
                <div className="col">
                    <span className="p-float-label cdm-float-label">
                        <Dropdown optionLabel="name" name='existingstructure' showClear disabled style={{ width: '90%' }} />
                        <label htmlFor="existingstructure">{I18n.get("Vos entreprises")}</label>
                    </span>
                </div>
            </div>
            <div className="grid">
                <div className="col">
                    <span className="p-float-label cdm-float-label">
                        <Dropdown name='existinguser' emptyMessage={I18n.get("Merci de sélectionner une entreprise")} disabled style={{ width: '90%' }} />
                        <label htmlFor="existinguser">{I18n.get("Utilisateur")}</label>
                    </span>
                </div>

            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col"><i className='fas fa-key' /> <b>{I18n.get("delegue")}</b></div>
            </div>
            <div className="grid">
                <div className="col">{I18n.get("delegue_compte")}</div>
            </div>
            <div className="grid">
                <div className="col">{I18n.get("delegue_tooltip")}</div>
            </div>
        </div>
    </>
    )
};